import React, { Component } from "react";
import axios from "axios";
import { Alert, Button } from "react-bootstrap";
import WorkspacePage from "../WorkspacePage";
import { link } from "../link.js";
import Auth from "../../Auth";
import PaymentTabs from "./PaymentTabs";

export class UploadPayments extends Component {
  state = {
    file: null,
    downloading: false,
    uploading: false,
    result: null,
  };

  downloadTemplate = async () => {
    this.setState({ downloading: true, result: null });
    try {
      const response = await axios.get(link() + "&ufile=paymenttemplate", {
        responseType: "blob",
        headers: { Authorization: `${localStorage.getItem("token")}` },
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "payments_upload_template.xlsx";
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      Auth.handleHttpCodes(error, "paymentUploadTemplate");
      this.setState({ result: { status: "Error", message: "The template could not be downloaded." } });
    } finally {
      this.setState({ downloading: false });
    }
  };

  uploadPayments = async (event) => {
    event.preventDefault();
    if (!this.state.file) return;

    const data = new FormData();
    data.append("file", this.state.file);
    this.setState({ uploading: true, result: null });
    try {
      const response = await axios.post(link() + "&ufile=paymentimport", data, {
        headers: { Authorization: `${localStorage.getItem("token")}` },
      });
      this.setState({ result: response.data });
    } catch (error) {
      Auth.handleHttpCodes(error, "paymentUpload");
      this.setState({ result: { status: "Error", message: "The payment file could not be uploaded." } });
    } finally {
      this.setState({ uploading: false });
    }
  };

  render() {
    const { file, downloading, uploading, result } = this.state;
    return (
      <WorkspacePage title="Upload Payments" actions={
        <Button variant="outline-secondary" type="button" onClick={this.downloadTemplate} disabled={downloading}>
          <i className="fas fa-download" aria-hidden="true" />
          {downloading ? "Preparing template..." : "Download Excel template"}
        </Button>
      }>
        <PaymentTabs />
        <section className="payment-import" aria-label="Payment import">
          <form className="payment-import-form" onSubmit={this.uploadPayments}>
            <div className="payment-import-field">
              <label htmlFor="payment-upload-file">Excel file</label>
              <input
                id="payment-upload-file"
                className="payment-import-file"
                type="file"
                accept=".xlsx,.xls"
                disabled={uploading}
                required
                onChange={(event) => this.setState({ file: event.target.files[0] || null, result: null })}
              />
            </div>
            <Button variant="success" type="submit" disabled={!file || uploading}>
              <i className="fas fa-upload" aria-hidden="true" />
              {uploading ? "Uploading..." : "Upload payments"}
            </Button>
          </form>
          {result && (
            <Alert variant={result.status === "Error" || (Array.isArray(result.errors) && result.errors.length > 0) ? "danger" : "success"} role="status" aria-live="polite" className="payment-import-result">
              <p>{result.message}</p>
              {Array.isArray(result.errors) && result.errors.length > 0 && (
                <ul>
                  {result.errors.map((item, index) => (
                    <li key={`${item.row}-${item.column}-${index}`}>
                      Row {item.row}, {item.column}: {item.message}
                    </li>
                  ))}
                </ul>
              )}
            </Alert>
          )}
        </section>
      </WorkspacePage>
    );
  }
}

export default UploadPayments;